import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxImageCompressService } from 'ngx-image-compress';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { showNotification } from 'src/app/helpers/show-toast';
import { Area } from 'src/app/_models/area.model';
import { Branch } from 'src/app/_models/branch.model';
import { City } from 'src/app/_models/city.model';
import { Country } from 'src/app/_models/country.mode';
import { AreaService } from 'src/app/_services/area.service';
import { BranchService } from 'src/app/_services/branch.service';
import { CityService } from 'src/app/_services/city.service';
import { CountriesService } from 'src/app/_services/countries.service';
import { baseUrl } from 'src/environments/environment';

@Component({
  selector: 'app-add-branch',
  templateUrl: './add-branch.component.html',
  styleUrls: ['./add-branch.component.scss'],
})
export class AddBranchComponent implements OnInit {
  pageTitle: string = 'Branches';
  currentBranchLink: string = '';
  countries: Country[];
  imageFile;
  editMode = false;
  cityId;
  cities: City[] = [];
  areas: Area[] = [];
  addBranchForm: FormGroup;
  isSubmited: boolean = false;
  branchFileName: string = '';
  branch: Branch = {
    name: '',
    arName: '',
    phone: '',
    email: '',
    isActive: true,
    cityId: 0,
    areaId: 0,
    address: '',
    arAddress: '',
    centerId: 3,
    city: {
      id: null,
      name: ''
    },
    area: {
      id: null,
      name: ''
    }
  };

  constructor(
    private branchService: BranchService,
    private areaService: AreaService,
    private cityService: CityService,
    private activatedRoute: ActivatedRoute,
    public toastr: ToastrService,
    private router: Router,
    private spinner: NgxSpinnerService,
    private imageCompress: NgxImageCompressService,
    private _formBuilder: FormBuilder
  ) {
    this.currentBranchLink = `/branches/${this.activatedRoute.snapshot.params.centerId}`;
  }

ngOnInit(): void {
  this.addBranchForm = this._formBuilder.group({
    branchEnName: [
      null,
      [Validators.required, Validators.pattern(/^[A-Za-z0-9 ,.\-!?\@\(\)]*$/)], // Updated to allow parentheses
    ],
    branchArName: [
      null,
      [Validators.required, Validators.pattern(/^[\u0621-\u064A0-9 ,.\-!?\@\(\)]*$/)], // Updated to allow parentheses
    ],
    branchEnAddress: [
      null,
      [Validators.required, Validators.pattern(/^[A-Za-z0-9 ,.\-!?\@\(\)]*$/)], // Updated to allow parentheses
    ],
    branchArAddress: [
      null,
      [Validators.required, Validators.pattern(/^[\u0621-\u064A0-9 ,.\-!?\@\(\)]*$/)], // Updated to allow parentheses
    ],
    branchPhone: [
      null,
      [Validators.required, Validators.pattern(/^[0-9]{5,11}$/)],
    ],
    branchEmail: [
      null,
      [
        Validators.required,
        Validators.pattern(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/),
      ],
    ],
    branchCity: [null, [Validators.required]],
    branchArea: [null, [Validators.required]],
    branchActive: [true, [Validators.required]],
  });

  this.getAllCities();

  this.editMode =
    this.activatedRoute.snapshot.url[2] &&
    this.activatedRoute.snapshot.url[2].path === 'edit' &&
    true;

  if (this.editMode) {
    const branchId = this.activatedRoute.snapshot.params.branchId;
    this.getBranchById(branchId);
  }
}



  getAllCities() {
    this.cityService.getAllCities().subscribe((res) => {
      res.map((city: City) => {
        if (city.isActive) {
          this.cities.push(city);
        }
      });
    });
  }

  getBranchById(id) {
    this.branchService.getBranchById(id).subscribe((res) => {4

      this.branch = res.data;

      document.getElementById(
        'placeholder'
      ).style.backgroundImage = `url(${res.data['logo']})`;

      this.addBranchForm.patchValue({
        branchEnName: this.branch.name,
        branchArName: this.branch.arName,
        branchEnAddress: this.branch.address,
        branchArAddress: this.branch.arAddress,
        branchPhone: this.branch.phone,
        branchEmail: this.branch.email,
        branchActive: this.branch.isActive,
        branchCity: this.branch.city?.id,
        branchArea: this.branch.area?.id,
      });

      this.getAreasByCityId(this.branch.city?.id);
    });
  }

  getAreasByCityId(cityId) {
    if (cityId) {
      this.areas = [];

      this.areaService.getAreasByCityId(cityId).subscribe((res) => {
        res?.data?.areas.map((area: Area) => {
          if (area.isActive) {
            this.areas.push(area);
          }
        });
      });
    }
  }

  onCityChange(cityId): void {
    if (cityId) {
      this.areas = [];

      const selectedCity = this.cities.find(city => city.id == cityId);

      selectedCity?.areas.forEach((area: Area) => {
        if (area.isActive) {
          this.areas.push(area);
        }
      });

      this.branch.city = {
        id: selectedCity.id,
        name: selectedCity.name
      }
    }
  }

  onAreaChange(areaId) {
    if(areaId) {
      const selectedArea = this.areas.find(area => area.id == areaId);

      this.branch.area = {
        id: selectedArea.id,
        name: selectedArea.name
      }
    }
  }

  onImageUpload(imageFile) {
    imageFile.preventDefault();
    return this.imageCompress.uploadFile().then(({ image, orientation }) => {
      console.warn('Size in bytes was:', this.imageCompress.byteCount(image));
      console.warn('Compressing and resizing to width 200px height 100px...');


      this.imageCompress
        .compressFile(image, orientation, 15, 20)
        .then((result: any) => {
          // this.branch.logoForm = result;
          this.branch.logoForm = this.dataURLtoFile(result, 'filename.png');
          const split = result.split(',');
          const type = split[0].replace('data:', '').replace(';base64', '');
          // this.imageFile = 'image has been selected';
          document.getElementById(
            'placeholder'
          ).style.backgroundImage = `url(${result})`;
          console.warn(
            'Size in bytes is now:',
            this.imageCompress.byteCount(result)
          );
        });
    });
  }

  dataURLtoFile(dataurl, filename) {
    const arr = dataurl.split(',');
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], filename, { type: mime });
  }

  buildBranchObject(data) {
    this.branch.name = data.branchEnName;
    this.branch.arName = data.branchArName;
    this.branch.address = data.branchEnAddress;
    this.branch.arAddress = data.branchArAddress;
    this.branch.phone = data.branchPhone;
    this.branch.email = data.branchEmail;
    this.branch.areaId = data.branchArea;
    this.branch.cityId = data.branchCity;
    this.branch.isActive = data.branchActive;
  }

  onAddBranchSubmit() {
    this.isSubmited = true;

    this.buildBranchObject(this.addBranchForm.value);
    this.branch.centerId = this.activatedRoute.snapshot.params.centerId;

    if (this.addBranchForm.valid) {
      if (this.editMode) {
        this.branchService.updateBranch(this.branch).subscribe((res) => {
          showNotification(
            'success',
            `${res['data'].name} has been updated`,
            this.toastr
          );
          this.router.navigateByUrl(this.currentBranchLink);
        });
      } else {
        this.branchService.addNewBranch(this.branch).subscribe((res) => {
          showNotification(
            'success',
            `${res['data'].name} has been added`,
            this.toastr
          );
          this.router.navigateByUrl(this.currentBranchLink);
        });
      }
    } else {
      showNotification(
        'danger',
        'You should fill the form fields with the correct data!',
        this.toastr
      );
    }
  }

  onAddBranch(): void {
    this.spinner.show();
    this.branch.centerId = this.activatedRoute.snapshot.params.centerId;

    if (this.editMode) {
      this.branchService.updateBranch(this.branch).subscribe((res) => {
        showNotification(
          'success',
          `${res['data']?.name} has been added`,
          this.toastr
        );
        this.spinner.hide();
        this.router.navigateByUrl('centers');
      });
    } else {
      this.branchService.addNewBranch(this.branch).subscribe((res) => {
        showNotification(
          'success',
          `${res.data.name} has been added`,
          this.toastr
        );
        this.spinner.hide();
        this.router.navigateByUrl('centers');
      });
    }
  }
}
